import { XCircleIcon } from '@heroicons/react/24/solid';

export const FullScreenModal = ({ closeModal, children }) => {
  return (
    <div className="no-scrollbar fixed top-0 left-0 z-100 flex h-screen w-screen flex-col items-center overflow-y-scroll bg-white px-5 pb-10">
      <div
        className="sticky top-0 z-100 flex items-center gap-3 self-end p-4 hover:cursor-pointer"
        onClick={closeModal}
      >
        <XCircleIcon className="size-10" />
        <span>Close</span>
      </div>
      {children}
    </div>
  );
};
